<script>
	import {
		dateToString,
		getDateLocales,
		stringToDate,
		isLastDate,
	} from "@xbs/lib-todo";
	import { getContext, createEventDispatcher } from "svelte";
	import { Calendar, Popup, Portal } from "@xbs/svelte-wx";
	import Icon from "../../../library/Icon.svelte";

	export let id;
	export let format = "%d %M %Y";
	export let value = null;
	export let validate = true;
	export let completed = false;
	export let open = false;
	export let readonly = false;

	const _ = getContext("wx-i18n").getGroup("todo");
	const _c = getContext("wx-i18n").getGroup("calendar");

	const dispatch = createEventDispatcher();

	let css = "wx-todo_date";
	let node = null;
	let area = null;

	$: if (value) {
		if (typeof value === "string") {
			value = stringToDate(value, format, false, getDateLocales(_c));
		}
		if (!value?.getTime()) value = null;

		if (validate && value instanceof Date) {
			css = isLastDate(value)
				? "wx-todo_date--current"
				: "wx-todo_date--expired";
		}
	}

	const dropdownOpen = () => {
		if (readonly) return;
		area = node.getBoundingClientRect();
		open = true;
		dispatch("action", {
			action: "set-state-due-date",
			data: { open: true, id },
		});
	};

	const dropdownClose = () => {
		open = false;
		area = null;
		dispatch("action", {
			action: "set-state-due-date",
			data: { open: false, id },
		});
	};

	const change = () => {
		dispatch("action", {
			action: "update-task",
			data: {
				id,
				task: {
					due_date: value || null,
				},
			},
		});
		dropdownClose();
	};

</script>

{#if value}
	<!-- svelte-ignore a11y-click-events-have-key-events -->
	<div
		class="wx-todo_due-date"
		class:completed
		on:click={dropdownOpen}
		bind:this={node}>
		<Icon name="calendar" {css} size={14} />
		<span class={css}>
			{#if value instanceof Date}
				{dateToString(value, format, getDateLocales(_c))}
			{:else}{_('Set due date')}{/if}
		</span>
		{#if open}
			<Portal let:mount>
				<Popup {mount} {area} cancel={dropdownClose}>
					<Calendar on:change={change} bind:value />
				</Popup>
			</Portal>
		{/if}
	</div>
{/if}

<style>
	.wx-todo_due-date {
		position: relative;
		cursor: pointer;
		display: flex;
		align-items: center;

		width: fit-content;
		margin-top: 4px;

		height: var(--wx-font-size-s);
		font-size: calc(var(--wx-font-size-s) - 1px);
		font-weight: var(--wx-font-weight-medium);
		line-height: var(--wx-font-size-s);
	}
	.wx-todo_due-date span {
		margin-left: 2px;
	}
	:global(.wx-todo_date),
	.completed :global(.wx-todo_date--current),
	.completed :global(.wx-todo_date--expired) {
		cursor: pointer;
		color: var(--wx-todo-date-color-regular);
	}

</style>
